import { EventSurface } from '../types/events';
var RouteToSurfaceMappings = {
    '/adp_iframe': EventSurface.LOGIN_IFRAME,
    '/': EventSurface.MODAL_INITIALIZATION,
    '/intro': EventSurface.INTRO,
    '/info': EventSurface.ABOUT_INFO,
    '/terms': EventSurface.TERMS_OF_SERVICE,
    '/privacy-policy': EventSurface.PRIVACY_POLICY,
    '/search': null,
    '/search/search': null,
    '/search/platforms': null,
    '/search/workday': null,
    '/link-api': null,
    '/link-api/dds': null,
    '/link-api/login': null,
    '/link-api/card-switch': null,
    '/link-api/bill-switch': null,
    '/link-api/bill-cancellation': null,
    '/link-api/guided-switch-primer': EventSurface.GUIDED_SWITCH_PRIMER,
    '/link-api/manual-instructions-fallback': EventSurface.MANUAL_INSTRUCTIONS_FALLBACK,
    '/link-api/manual-instructions-display': EventSurface.MANUAL_INSTRUCTIONS,
    '/error': EventSurface.JOB_ERROR,
    '/amount-selection': EventSurface.DD_AMOUNT_SELECTION,
    '/multiple-amount-selection': EventSurface.MULTIPLE_ACCOUNTS_SELECTION,
    '/bank-info-input': EventSurface.BANK_INFO_INPUT,
    '/dd-form': null,
    '/dd-form/amount-selection': EventSurface.DD_AMOUNT_SELECTION,
    '/dd-form/confirmation-screen': EventSurface.DD_FORM_CONFIRM,
    '/dd-form/employer-name-entry': EventSurface.EMPLOYER_INPUT,
    '/dd-form/user-name-entry': EventSurface.NAME_INPUT,
    '/dd-form/signature-style-selection': EventSurface.SIGNATURE_SELECTION,
    '/dd-form/document-display': EventSurface.DD_FORM_SUCCESS,
    '/dd-form/multiple-account-selection': EventSurface.MULTIPLE_ACCOUNTS_SELECTION,
    '/dd-form/bank-info-input': EventSurface.BANK_INFO_INPUT,
    '/success': EventSurface.JOB_SUCCESS,
    '/dd-form/primer': EventSurface.DD_FORM_PRIMER,
    '/switch-confirmation': EventSurface.DD_CONFIRMATION,
    '/card-switch': null,
    '/card-switch/confirm': EventSurface.CARD_SWITCH_PROMPT,
    '/card-switch/dds-card-success': EventSurface.JOB_SUCCESS,
    '/card-switch/card-error': EventSurface.JOB_ERROR,
    '/card-switch/dds-error': EventSurface.JOB_ERROR,
    '/document-uploads': null,
    '/document-uploads/primer': EventSurface.DOCUMENT_UPLOADS_PRIMER,
    '/document-uploads/submitted': EventSurface.DOCUMENT_UPLOADS_SUBMITTED,
    '/document-uploads/delete/:fileId': EventSurface.DOCUMENT_UPLOADS_DELETE,
    '/document-uploads/repair/:fileId': EventSurface.DOCUMENT_UPLOADS_REPAIR,
    '/document-uploads/list': EventSurface.DOCUMENT_UPLOADS_LIST,
    // TODO: We need to add surfaces here for the new screens
    '/multi-supplier-eligibility': null,
    '/multi-supplier-eligibility/lookup': EventSurface.PLATFORM_ELIGIBILITY_LOOKUP_LOADING,
    '/multi-supplier-eligibility/help': EventSurface.PLATFORM_ELIGIBILITY_LOOKUP_HELP,
    '/multi-supplier-eligibility/results': null,
    '/return_to_search': EventSurface.RETURN_TO_SEARCH,
    '/account-selection': EventSurface.MULTIPLE_ACCOUNTS_SELECTION,
    '/wizard': null,
    '/wizard/income-sources': EventSurface.WIZARD_INCOME_SOURCES,
    '/wizard/payment-methods': EventSurface.WIZARD_PAYMENT_METHODS,
    '/wizard/income-source-1099': EventSurface.WIZARD_INCOME_SOURCE_1099,
    '/wizard/income-source-w2': EventSurface.WIZARD_INCOME_SOURCE_W2,
    '/wizard/income-source-benefits': EventSurface.WIZARD_INCOME_SOURCE_BENEFITS,
    '/wizard/wizard-error': EventSurface.WIZARD_ERROR,
    '/bill-navigator-iframe': EventSurface.BILL_NAVIGATOR,
    '/pii-data': null,
    '/pii-data/name': EventSurface.PII_NAME_ENTRY,
    '/pii-data/tel': EventSurface.PII_TEL_ENTRY,
    '/pii-data/dob': EventSurface.PII_DOB_ENTRY,
    '/pii-data/ssn4': EventSurface.PII_SSN4_ENTRY,
    '/pii-data/ssn9': EventSurface.PII_SSN9_ENTRY,
    '/pii-data/review': EventSurface.PII_REVIEW,
};
export default RouteToSurfaceMappings;
